import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { supabase, isConfigured } from '../lib/supabase.js'
import Seo from '../components/Seo.jsx'

/*
 * Double-opt-in confirmation for the promo list (/confirm?token=…). The link is
 * sent inside the "your calculation" email when the visitor ticked the offers box.
 */
export default function Confirm() {
  const [params] = useSearchParams()
  const token = params.get('token')
  const [status, setStatus] = useState('working') // working | done | error

  useEffect(() => {
    if (!token || !isConfigured) return setStatus('error')
    supabase.rpc('confirm_lead', { p_token: token })
      .then(({ data, error }) => setStatus(error || !data ? 'error' : 'done'))
  }, [token])

  return (
    <main className="page">
      <Seo title="Confirm your email | CalculateMyPeptides" noindex />
      <div className="container page-narrow" style={{ maxWidth: 520 }}>
        <div className="card card-pad center" style={{ padding: '40px 30px' }}>
          {status === 'working' && (<><div className="spinner" /><p className="muted" style={{ marginTop: 14 }}>Confirming…</p></>)}
          {status === 'done' && (
            <>
              <div style={{ fontSize: '2.4rem', marginBottom: 8 }}>✅</div>
              <h1 className="section-title">You’re confirmed</h1>
              <p className="soft">You’ll get occasional product offers and deals. You can unsubscribe from any email.</p>
              <Link to="/calculator" className="btn btn-primary" style={{ marginTop: 12 }}>Back to the calculator</Link>
            </>
          )}
          {status === 'error' && (
            <>
              <div style={{ fontSize: '2.4rem', marginBottom: 8 }}>⚠️</div>
              <h1 className="section-title">That link didn’t work</h1>
              <p className="soft">It may have expired or already been used. No worries — nothing’s wrong on your end.</p>
              <Link to="/calculator" className="btn btn-primary" style={{ marginTop: 12 }}>Back to the calculator</Link>
            </>
          )}
        </div>
      </div>
    </main>
  )
}
